<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>The Power of Your Past</strong></h1>
<p class="subtitle"><em>The Art of Recalling, Reclaiming, and Recasting</em></p>
<p class="author1">John P. Schuster</p>
<p class="pubimage"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?bf85fc46